import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { PlusCircle, Loader2, ChevronRight, Wrench } from 'lucide-react';
import { Button } from '../../components/ui/button';
import api from '../api';
import { INTERVENTION_STATUS, INTERVENTION_TYPES, URGENCY_LEVELS, formatDate } from '../constants';

const ClientDashboard = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get('/interventions');
        setItems(data);
      } catch (e) { /* interceptor */ } finally { setLoading(false); }
    })();
  }, []);

  return (
    <div data-testid="client-dashboard">
      <div className="flex items-center justify-between mb-5">
        <h1 className="text-xl font-bold text-neutral-900">Mes demandes d'intervention</h1>
        <Link to="/espace-client/nouvelle-demande">
          <Button className="bg-red-700 hover:bg-red-600" data-testid="client-new-request-button">
            <PlusCircle className="w-4 h-4 mr-2" />Nouvelle demande
          </Button>
        </Link>
      </div>

      {loading ? (
        <div className="flex justify-center py-16"><Loader2 className="w-8 h-8 animate-spin text-red-700" /></div>
      ) : items.length === 0 ? (
        <div className="bg-white rounded-xl border border-neutral-200 p-10 text-center">
          <Wrench className="w-10 h-10 text-neutral-300 mx-auto mb-3" />
          <p className="text-neutral-500 mb-4">Vous n'avez aucune demande pour le moment.</p>
          <Link to="/espace-client/nouvelle-demande">
            <Button className="bg-red-700 hover:bg-red-600"><PlusCircle className="w-4 h-4 mr-2" />Déposer une demande</Button>
          </Link>
        </div>
      ) : (
        <div className="space-y-3">
          {items.map((it) => {
            const st = INTERVENTION_STATUS[it.status] || {};
            const ur = URGENCY_LEVELS[it.urgency] || {};
            return (
              <Link key={it.id} to={`/espace-client/demande/${it.id}`} data-testid={`client-request-${it.number}`}
                className="flex items-center justify-between bg-white rounded-xl border border-neutral-200 p-4 hover:shadow-sm transition-shadow">
                <div className="min-w-0">
                  <div className="flex flex-wrap items-center gap-2 mb-1">
                    <span className="font-bold text-neutral-900">{it.number}</span>
                    <span className="text-xs bg-neutral-100 text-neutral-600 px-2 py-0.5 rounded">{INTERVENTION_TYPES[it.type]}</span>
                    <span className={`text-xs px-2 py-0.5 rounded ${ur.color}`}>{ur.label}</span>
                  </div>
                  <p className="text-sm text-neutral-500 truncate">{it.description}</p>
                  <p className="text-xs text-neutral-400 mt-1">{formatDate(it.createdAt)}</p>
                </div>
                <div className="flex items-center gap-3 shrink-0 ml-3">
                  <span className={`text-xs px-2 py-1 rounded ${st.color}`}>{st.label}</span>
                  <ChevronRight className="w-5 h-5 text-neutral-300" />
                </div>
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ClientDashboard;
